import { render } from "./FeedbackView.vue?vue&type=template&id=64af06f8"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__